import { CoreIcon } from '../core-icon';
import lockSVG from '../../../src/images/icons/lock.svg';

export const LockIcon = props => {
  return <CoreIcon src={lockSVG} {...props} />;
};
